export class NachweisDto {
  constructor(public id: string, public dateiname: string) {
  }
}
